import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  imageLabel: {
    height: 45,
    width: 'auto',
    margin: 'auto',
    borderRadius: 3
  },
}));
